/**
 * We deliberately chose Server Side Rendering here, to make sure it works from the JS side of
 * things.
 */
export async function getServerSideProps() {
    return { props: { response: 'Pong' } };
}
